import { getBoolVariation } from "./featbit";
import { addRumAction } from "./logs";
export var logFilesWhichUseBrowserCache = function () {
    if (!getBoolVariation('cyxq-84474-static-resource-report', false)) {
        return;
    }
    try {
        requestIdleCallback(function () {
            var fileNameMatch = [
                "/ekb/runtime~",
                "/plugin-web-invoice-domain/plugin-web-invoice-domain.",
                "/plugin-web-organization-domain/plugin-web-organization-domain.",
                "/plugin-web-datalink-domain/plugin-web-datalink-domain.",
                "/plugin-web-settlement-checking-domain/plugin-web-settlement-checking-domain.",
                "/plugin-web-home-domain/plugin-web-home-domain.",
                "/plugin-web-report-domain/plugin-web-report-domain.",
                "/plugin-web-pay-domain/plugin-web-pay-domain.",
                "/plugin-web-account5/plugin-web-account5.",
                "/plugin-web-dimension-domain/plugin-web-dimension-domain.",
                "/plugin-web-business-to-business/plugin-web-business-to-business.",
                "/plugin-web-specification-domain/plugin-web-specification-domain.",
                "/plugin-web-approval-copilot-domain/plugin-web-approval-copilot-domain.",
                "/plugin-web-bills-domain/plugin-web-bills-domain.",
            ];
            var resources = performance.getEntriesByType('resource');
            var matchFiles = resources.filter(function (resource) {
                return fileNameMatch.some(function (match) { return resource.name.includes(match); });
            });
            var resourceCached = matchFiles.filter(function (file) { return file.transferSize === 0; });
            if (resourceCached.length > 0) {
                var extraDomainNameAndHashCode_1 = function (pathname) {
                    var result = /plugin-web-([a-zA-Z]+)-domain\.([0-9a-zA-Z]+)\.js/.exec(pathname);
                    if ((result === null || result === void 0 ? void 0 : result.length) > 2) {
                        return {
                            domainName: result[1],
                            hashCode: result[2],
                        };
                    }
                    return null;
                };
                var objStr = JSON.stringify(resourceCached.reduce(function (calc, cur) {
                    var res = extraDomainNameAndHashCode_1(cur.name);
                    if (res) {
                        calc[res.domainName] = res.hashCode;
                    }
                    return calc;
                }, {}));
                addRumAction('[Debug] Files_Cached_By_Browsee', {
                    title: '文件使用了浏览器缓存',
                    bc_count: resourceCached.length,
                    bc_total_count: matchFiles.length,
                    bc_file_names: objStr,
                });
            }
        });
    }
    catch (error) {
        console.error("logFilesWhichUseBrowserCache 中出现异常", error);
    }
};
